import React from 'react'

const MoneyTransfersToolbar = () => {
  return (
    <div>
      <div className="toolbar-filters"></div>
      <div />
    </div>
  )
}

export default MoneyTransfersToolbar
